import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  constainer: {
    marginTop: "8em",
  },
  shareText: {
    fontSize: "1.5rem",
    fontWeight: "bold",
  },
  lastPost: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    margin: "3em 0 1.5em",
    borderBottom: "2px solid rgb(208 208 208)",
  },
}));
export default useStyles;
